// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"388":"d844da4d","498":"460bff2a","598":"0f22a655","703":"397093ea","787":"7922278b"}[chunkId] + ".chunk.js";
};